import React from 'react';
import { Outlet } from 'react-router-dom';
import { makeStyles } from '@fluentui/react-components';

const useStyles = makeStyles({
    locationLayout: {
        backgroundColor: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
    },
    
    content: {
        flex: 1,
    },
});

export const LocationLayout: React.FC = () => {
    const styles = useStyles();

    return (
        <div className={styles.locationLayout}>
            <div className={styles.content}>
                <Outlet />
            </div>
        </div>
    );
};
